import Head from 'next/head'

import Layout from '@/components/Layout'
import HeaderImg from '@/public/img/call-center.jpg'

export default function CallCenter(): JSX.Element {
	return (
		<div className="container mx-auto max-w-screen-xl lg:px-12">
			<Head>
				<title key="page-title">Call Center Solutions | Pace International</title>
			</Head>

			<h1 className="text-4xl font-extrabold px-4 mt-4 uppercase md:mt-6 xl:text-5xl">Call Center</h1>

			<img className="mt-4 lg:mt-6" src={HeaderImg} alt="Header"/>

			<div className="pt-4 pb-8 px-4 lg:pt-6 lg:pb-12">
				<h1 className="text-xl italic font-semibold text-center">“Hello, how can Pace International assist with your equipment activations, subscriber management and more?”</h1>

				<p className="mt-4 lg:mt-6">Pace's call center makes working with us and your equipment a breeze. We have built its reputation on unparalleled customer service and we will go the extra mile to make sure you and your customers are completely satisfied. If you have questions about shipping, technical support, programming and subscriber management, Pace is available regularly to help overcome any challenges.</p>

				<p className="mt-4 lg:mt-6">When you buy from Pace, your can count on more than just the right solution and the highest quality technical service for the job. Pace doesn’t only supply your business with products, we are proud to continue to support and service your business and customers by providing the answers and insights necessary for success.</p>
			</div>
		</div>
	)
}

CallCenter.Layout = Layout
